// import React, { useState, useEffect } from 'react';
// import { Icon } from '@chakra-ui/react';
// import {
//   Box,
//   Button,
//   Flex,
//   Table,
//   Tbody,
//   Td,
//   Text,
//   Th,
//   Thead,
//   Tr,
//   useColorModeValue,
//   Skeleton,
// } from '@chakra-ui/react';
// import { ChevronRightIcon, ChevronLeftIcon } from '@chakra-ui/icons';
// import {
//   flexRender,
//   getCoreRowModel,
//   getSortedRowModel,
//   useReactTable,
//   getPaginationRowModel,
// } from '@tanstack/react-table';
// import Card from 'components/card/Card';
// import { FaCaretSquareDown, FaCaretSquareUp } from 'react-icons/fa';
// import { Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
// import { SearchIcon } from '@chakra-ui/icons';

// export default function ComplexTable(props) {
//   const {
//     tableData,
//     columnsData,
//     loading = false,
//     fetchAllDevices,
//     hasNext,
//     title = 'All Devices',
//   } = props;

//   const textColor = useColorModeValue('secondaryGray.900', 'white');
//   const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
//   const bg = useColorModeValue('whiteAlpha.200', 'navy.600');

//   const [data, setData] = useState(() => [...tableData]);
//   const [columns, setColumns] = useState(() => [...columnsData]);
//   const [sorting, setSorting] = useState([]);
//   const [serialNumber, setSerialNumber] = useState('');
//   const [pageNumber, setPageNumber] = useState(0);

//   useEffect(() => {
//     if (tableData && Array.isArray(tableData)) {
//       setData(tableData);
//     }
//   }, [tableData]);

//   // --- Search logic ---
//   useEffect(() => {
//     if (typeof fetchAllDevices === 'function') {
//       setPageNumber(0); // Reset to first page when search changes
//       fetchAllDevices(serialNumber, false, 0);
//     } else {
//       // Local search: filter tableData by serialNumber (case-insensitive, partial match)
//       if (!serialNumber) {
//         setData(tableData);
//       } else {
//         const search = serialNumber.toLowerCase();
//         setData(
//           tableData.filter((row) =>
//             Object.values(row).join(' ').toLowerCase().includes(search),
//           ),
//         );
//       }
//     }
//   }, [serialNumber, fetchAllDevices, tableData]);
//   // ---------------------

//   const getNext = () => {
//     if (typeof fetchAllDevices === 'function') {
//       const newNumber = pageNumber + 1;
//       setPageNumber(newNumber);
//       fetchAllDevices(serialNumber, false, newNumber);
//     }
//   };

//   const getPrevious = () => {
//     if (typeof fetchAllDevices === 'function' && pageNumber > 0) {
//       const newNumber = pageNumber - 1;
//       setPageNumber(newNumber);
//       fetchAllDevices(serialNumber, false, newNumber);
//     }
//   };

//   useEffect(() => {
//     if (columnsData && Array.isArray(columnsData)) {
//       setColumns(columnsData);
//     }
//   }, [columnsData]);

//   const table = useReactTable({
//     data,
//     columns,
//     state: { sorting },
//     onSortingChange: setSorting,
//     getCoreRowModel: getCoreRowModel(),
//     getSortedRowModel: getSortedRowModel(),
//     getPaginationRowModel: getPaginationRowModel(),
//     initialState: {
//       pagination: {
//         pageSize,
//         pageIndex: 0,
//       },
//     },
//   });

//   const skeletonRows = pageSize;

//   return (
//     <Card
//       flexDirection="column"
//       w="100%"
//       px="0px"
//       overflowX={{ sm: 'scroll', lg: 'hidden' }}
//     >
//       <Flex px="25px" mb="8px" justifyContent="space-between" align="center">
//         <Text
//           color={textColor}
//           fontSize="22px"
//           fontWeight="700"
//           lineHeight="100%"
//         >
//           {title}
//         </Text>

//         <InputGroup width="400px" bg={bg} borderRadius="1rem">
//           <InputLeftElement>
//             <SearchIcon borderRadius="2rem" color="navy.500" />
//           </InputLeftElement>
//           <Input
//             borderRadius="1rem"
//             border="2px lightgray solid"
//             type="text"
//             value={serialNumber}
//             onChange={(e) => setSerialNumber(e.target.value)}
//             color={textColor}
//             placeholder="Search..."
//             outline="none"
//             _focus={{ boxShadow: 'none' }}
//           />
//         </InputGroup>
//       </Flex>

//       <Box>
//         <Table variant="simple" color="gray.500" mb="24px" mt="12px">
//           <Thead>
//             {table.getHeaderGroups().map((headerGroup) => (
//               <Tr key={headerGroup.id}>
//                 {headerGroup.headers.map((header) => (
//                   <Th
//                     key={header.id}
//                     colSpan={header.colSpan}
//                     pe="10px"
//                     borderColor={borderColor}
//                     cursor="pointer"
//                     onClick={header.column.getToggleSortingHandler()}
//                   >
//                     <Flex
//                       justifyContent="space-between"
//                       align="center"
//                       fontSize={{ sm: '10px', lg: '12px' }}
//                       color="gray.400"
//                     >
//                       {flexRender(
//                         header.column.columnDef.header,
//                         header.getContext(),
//                       )}
//                       {{
//                         asc: <Icon as={FaCaretSquareUp} color="gray.500" />,
//                         desc: <Icon as={FaCaretSquareDown} color="gray.500" />,
//                       }[header.column.getIsSorted()] ?? null}
//                     </Flex>
//                   </Th>
//                 ))}
//               </Tr>
//             ))}
//           </Thead>

//           <Tbody>
//             {loading
//               ? Array.from({ length: skeletonRows }).map((_, i) => (
//                   <Tr key={`skeleton-${i}`}>
//                     {columns.map((col, idx) => (
//                       <Td
//                         key={idx}
//                         fontSize={{ sm: '14px' }}
//                         minW={{ sm: '150px', md: '200px', lg: 'auto' }}
//                         borderColor="transparent"
//                       >
//                         <Skeleton height="20px" />
//                       </Td>
//                     ))}
//                   </Tr>
//                 ))
//               : table.getRowModel().rows.map((row) => (
//                   <Tr key={row.id}>
//                     {row.getVisibleCells().map((cell) => (
//                       <Td
//                         key={cell.id}
//                         fontSize={{ sm: '14px' }}
//                         minW={{ sm: '150px', md: '200px', lg: 'auto' }}
//                         borderColor="transparent"
//                       >
//                         {flexRender(
//                           cell.column.columnDef.cell,
//                           cell.getContext(),
//                         )}
//                       </Td>
//                     ))}
//                   </Tr>
//                 ))}
//           </Tbody>
//         </Table>
//       </Box>

//       {/* Pagination Controls */}
//       <Flex justify="space-between" align="center" p={2}>
//         <Button
//           size="md"
//           onClick={() => getPrevious()}
//           isDisabled={pageNumber === 0}
//         >
//           <ChevronLeftIcon />
//         </Button>
//         <Text>
//           Page {table.getState().pagination.pageIndex + 1} of{' '}
//           {table.getPageCount()}
//         </Text>
//         <Button size="md" onClick={() => getNext()} isDisabled={!hasNext}>
//           <ChevronRightIcon />
//         </Button>
//       </Flex>
//     </Card>
//   );
// }

import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Center, Icon } from '@chakra-ui/react';
import {
  Box,
  Button,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Skeleton,
} from '@chakra-ui/react';
import {
  ChevronRightIcon,
  ChevronLeftIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  SkipBackIcon,
  SkipForwardIcon,
} from '@chakra-ui/icons';
import {
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
  getPaginationRowModel,
} from '@tanstack/react-table';
import Card from 'components/card/Card';
import { FaCaretSquareDown, FaCaretSquareUp } from 'react-icons/fa';
import { Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';
import { MdSkipNext, MdSkipPrevious } from 'react-icons/md';

export default function ComplexTable(props) {
  const {
    tableData,
    columnsData,
    loading = false,
    fetchAllDevices,
    hasNext,
    title = 'All Devices',
    totalPages,
    pageSize = 10,
    enableLocalPagination = false,
    showFirstLastButtons = false,
  } = props;

  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const bg = useColorModeValue('whiteAlpha.200', 'navy.600');

  // Fix initial state to avoid errors if tableData/columnsData are undefined
  const [data, setData] = useState(() =>
    Array.isArray(tableData) ? [...tableData] : [],
  );
  const [columns, setColumns] = useState(() =>
    Array.isArray(columnsData) ? [...columnsData] : [],
  );
  const [sorting, setSorting] = useState([]);
  const [serialNumber, setSerialNumber] = useState('');
  const [pageNumber, setPageNumber] = useState(0);

  // Local pagination state
  const [localPageIndex, setLocalPageIndex] = useState(0);

  // Add refs for timeout and previous search term
  const searchTimeoutRef = useRef(null);
  const previousSearchRef = useRef('');

  // Add state to track filtered columns for local search
  const [filteredColumns, setFilteredColumns] = useState(null);

  useEffect(() => {
    if (tableData && Array.isArray(tableData)) {
      setData(tableData);
    }
  }, [tableData]);

  // Always update data from tableData unless a local search is active
  useEffect(() => {
    if (!serialNumber) {
      setData(Array.isArray(tableData) ? tableData : []);
      setFilteredColumns(null);
      setColumns(Array.isArray(columnsData) ? columnsData : []);
    }
    // If local search is active, don't override data
  }, [tableData, columnsData, serialNumber]);

  // Debounced search function
  const performSearch = useCallback(
    (searchValue) => {
      if (typeof fetchAllDevices === 'function') {
        setPageNumber(0);
        setLocalPageIndex(0);
        fetchAllDevices(searchValue, false, 0);
      }
    },
    [fetchAllDevices],
  );

  // Handle search input changes with proper debouncing
  const handleSearchChange = useCallback(
    (value) => {
      setSerialNumber(value);
      setLocalPageIndex(0); // Reset to first page when searching

      // For API search with debouncing
      if (typeof fetchAllDevices === 'function') {
        // Clear previous timeout
        if (searchTimeoutRef.current) {
          clearTimeout(searchTimeoutRef.current);
        }

        // Only search if the value has actually changed and not empty to empty
        if (
          value !== previousSearchRef.current ||
          (value === '' && previousSearchRef.current !== '')
        ) {
          // Set new timeout for debounced search
          searchTimeoutRef.current = setTimeout(() => {
            performSearch(value);
            previousSearchRef.current = value;
          }, 500); // 500ms debounce delay
        }
      } else {
        // For local search: filter tableData (search both keys AND values)
        if (!value) {
          setData(tableData); // <-- always show filtered logs if no search
          setFilteredColumns(null);
          setColumns(columnsData);
        } else {
          const search = value.toLowerCase();
          // Case-insensitive column name match (handles all caps headers)
          const matchedCol = columnsData.find((col) => {
            let headerStr = '';
            if (typeof col.header === 'string') {
              headerStr = col.header;
            } else if (typeof col.header === 'function') {
              // If header is a function, try to get its name or fallback
              headerStr = col.header.name || '';
            } else {
              headerStr = String(col.header || '');
            }
            return headerStr.toLowerCase().includes(search);
          });
          if (matchedCol) {
            // Show only the first column and the matched column
            const firstCol = columnsData[0];
            // Avoid duplicate if firstCol is the matchedCol
            const colsToShow =
              firstCol.accessorKey === matchedCol.accessorKey
                ? [firstCol]
                : [firstCol, matchedCol];
            setFilteredColumns(colsToShow);
            setColumns(colsToShow);
            setData(tableData);
          } else {
            // Value search: show all columns
            setFilteredColumns(null);
            setColumns(columnsData);
            setData(
              tableData.filter((row) =>
                Object.entries(row).some(
                  ([key, value]) =>
                    key.toLowerCase().includes(search) ||
                    String(value || '')
                      .toLowerCase()
                      .includes(search),
                ),
              ),
            );
          }
        }
      }
    },
    [fetchAllDevices, tableData, columnsData],
  );

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);

  // API-based pagination handlers
  const getNext = () => {
    if (typeof fetchAllDevices === 'function') {
      const newNumber = pageNumber + 1;
      setPageNumber(newNumber);
      fetchAllDevices(serialNumber, false, newNumber);
    } else if (enableLocalPagination) {
      // Local pagination next
      setLocalPageIndex((prev) => prev + 1);
    }
  };

  const getPrevious = () => {
    if (typeof fetchAllDevices === 'function' && pageNumber > 0) {
      const newNumber = pageNumber - 1;
      setPageNumber(newNumber);
      fetchAllDevices(serialNumber, false, newNumber);
    } else if (enableLocalPagination && localPageIndex > 0) {
      // Local pagination previous
      setLocalPageIndex((prev) => prev - 1);
    }
  };

  const goToFirstPage = () => {
    if (typeof fetchAllDevices === 'function') {
      setPageNumber(0);
      fetchAllDevices(serialNumber, false, 0);
    } else if (enableLocalPagination) {
      setLocalPageIndex(0);
    }
  };

  const goToLastPage = () => {
    if (
      typeof fetchAllDevices === 'function' &&
      typeof totalPageCount === 'number'
    ) {
      const lastPage = totalPageCount - 1;
      setPageNumber(lastPage);
      fetchAllDevices(serialNumber, false, lastPage);
    } else if (enableLocalPagination) {
      const lastPage = totalPageCount - 1;
      setLocalPageIndex(lastPage);
    }
  };

  useEffect(() => {
    if (columnsData && Array.isArray(columnsData)) {
      setColumns(columnsData);
    }
  }, [columnsData]);

  // Configure react-table based on pagination mode
  const tableConfig = {
    data,
    columns,
    state: { sorting },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  };

  // Add pagination model only for local pagination
  if (enableLocalPagination && typeof fetchAllDevices !== 'function') {
    tableConfig.getPaginationRowModel = getPaginationRowModel();
    tableConfig.initialState = {
      pagination: {
        pageSize,
        pageIndex: localPageIndex,
      },
    };
    // Manual pagination state for local control
    tableConfig.state = {
      ...tableConfig.state,
      pagination: {
        pageSize,
        pageIndex: localPageIndex,
      },
    };
    tableConfig.onPaginationChange = (updater) => {
      const newState =
        typeof updater === 'function'
          ? updater({ pageIndex: localPageIndex, pageSize })
          : updater;
      setLocalPageIndex(newState.pageIndex);
    };
  }

  const table = useReactTable(tableConfig);

  // Determine current page data based on pagination mode
  let currentPageData = data;
  let totalPageCount = 1;
  let currentPageIndex = 0;

  if (typeof fetchAllDevices === 'function') {
    // API pagination
    currentPageIndex = pageNumber;
    totalPageCount =
      typeof totalPages === 'number'
        ? totalPages
        : pageNumber + (hasNext ? 2 : 1);
  } else if (enableLocalPagination) {
    // Local pagination
    currentPageData = table.getRowModel().rows.map((row) => row.original);
    currentPageIndex = localPageIndex;
    totalPageCount = table.getPageCount();
  }

  const skeletonRows = pageSize;

  // Determine if previous/next buttons should be disabled
  const isPreviousDisabled =
    typeof fetchAllDevices === 'function'
      ? pageNumber === 0 || loading
      : enableLocalPagination
        ? localPageIndex === 0 || loading
        : true;

  const isNextDisabled =
    typeof fetchAllDevices === 'function'
      ? !hasNext || loading
      : enableLocalPagination
        ? localPageIndex >= totalPageCount - 1 || loading
        : true;

  return (
    <Card
      flexDirection="column"
      w="100%"
      px="0px"
      overflowX={{ sm: 'scroll', lg: 'hidden' }}
    >
      <Flex
        px="25px"
        mb="8px"
        justifyContent="space-between"
        align="center"
        alignItems="center"
      >
        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
        >
          {title}
        </Text>

        <InputGroup width="400px" bg={bg} borderRadius="1rem">
          <InputLeftElement>
            <SearchIcon borderRadius="2rem" color="navy.500" />
          </InputLeftElement>
          <Input
            borderRadius="1rem"
            border="2px lightgray solid"
            type="text"
            value={serialNumber}
            onChange={(e) => handleSearchChange(e.target.value)}
            color={textColor}
            placeholder="Search..."
            outline="none"
            _focus={{ boxShadow: 'none' }}
          />
        </InputGroup>
      </Flex>

      <Box>
        {/* Make table horizontally scrollable if columns overflow */}
        <Box overflowX="auto">
          <Table variant="simple" color="gray.500" mb="24px" mt="12px">
            <Thead>
              {table.getHeaderGroups().map((headerGroup) => (
                <Tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => (
                    <Th
                      key={header.id}
                      colSpan={header.colSpan}
                      pe="10px"
                      borderColor={borderColor}
                      cursor="pointer"
                      onClick={header.column.getToggleSortingHandler()}
                    >
                      <Flex
                        justifyContent="space-between"
                        fontSize={{ sm: '10px', lg: '12px' }}
                        color="gray.400"
                        textAlign="center"
                      >
                        {flexRender(
                          header.column.columnDef.header,
                          header.getContext(),
                        )}
                        {{
                          asc: <Icon as={FaCaretSquareUp} color="gray.500" />,
                          desc: (
                            <Icon as={FaCaretSquareDown} color="gray.500" />
                          ),
                        }[header.column.getIsSorted()] ?? null}
                      </Flex>
                    </Th>
                  ))}
                </Tr>
              ))}
            </Thead>

            <Tbody>
              {loading ? (
                Array.from({ length: skeletonRows }).map((_, i) => (
                  <Tr key={`skeleton-${i}`}>
                    {columns.map((col, idx) => (
                      <Td
                        key={idx}
                        fontSize={{ sm: '14px' }}
                        minW={{ sm: '150px', md: '200px', lg: 'auto' }}
                        borderColor="transparent"
                      >
                        <Skeleton height="20px" />
                      </Td>
                    ))}
                  </Tr>
                ))
              ) : currentPageData.length > 0 ? (
                table.getRowModel().rows.map((row) => (
                  <Tr key={row.id}>
                    {(filteredColumns || columns).map((col, idx) => {
                      // Find the cell for this column
                      const colId = col.id || col.accessorKey; // <-- fallback to accessorKey
                      const cell = row
                        .getVisibleCells()
                        .find((c) => c.column.id === colId);
                      return (
                        <Td
                          key={col.accessorKey || col.id || idx}
                          fontSize={{ sm: '14px' }}
                          minW={{ sm: '150px', md: '200px', lg: 'auto' }}
                          borderColor="transparent"
                        >
                          {cell
                            ? flexRender(
                                cell.column.columnDef.cell,
                                cell.getContext(),
                              )
                            : null}
                        </Td>
                      );
                    })}
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan={columns.length} textAlign="center" py={8}>
                    <Text color="gray.500">No data found</Text>
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </Box>
      </Box>

      {(typeof fetchAllDevices === 'function' || enableLocalPagination) && (
        <Flex justify="space-between" align="center" alignItems="center" p={2}>
          <Flex>
            {showFirstLastButtons && (
              <Button
                size="md"
                onClick={goToFirstPage}
                isDisabled={isPreviousDisabled}
                mr={2}
                aria-label="First Page"
              >
                <MdSkipPrevious />
              </Button>
            )}
            <Button
              size="md"
              onClick={getPrevious}
              isDisabled={isPreviousDisabled}
            >
              <ChevronLeftIcon />
            </Button>
          </Flex>
          <Text>
            Page {currentPageIndex + 1}
            {totalPageCount > 0 ? ` of ${totalPageCount}` : ''}
          </Text>
          <Flex>
            <Button size="md" onClick={getNext} isDisabled={isNextDisabled}>
              <ChevronRightIcon />
            </Button>
            {showFirstLastButtons && (
              <Button
                size="md"
                onClick={goToLastPage}
                isDisabled={isNextDisabled}
                ml={2}
                aria-label="Last Page"
              >
                <MdSkipNext />
              </Button>
            )}
          </Flex>
        </Flex>
      )}
    </Card>
  );
}
